import { ref, reactive } from 'vue';
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
//import dayjs from 'dayjs';
import { Post, Get } from '@/api/Api';
import { ls } from 'vue-lsp';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  name: 'Index',
  components: {},
  setup(props, context) {
    const RefForm = ref();
    const IsShow = ref(false);
    const DMConfig = reactive({
      FId: 0,
      Title: '',
      Width: '0',
      Height: '0',
      loading: false,
      ModelClass: '',
      TermsOfSaleList: [],
      PortOfLoadingList: [],
      SettleList: [],
      Model: {
        deliverToList: []
      },
      DMForm: {
        form: {
          labelCol: {
            style: {
              width: '160px'
            }
          }
        }
      },
      Columns: [{
        title: "DeliverTo",
        dataIndex: "deliverTo",
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "DeliverTo1",
        dataIndex: "deliverTo1",
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "DeliverTo2",
        dataIndex: "deliverTo2",
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "DeliverTo3",
        dataIndex: "deliverTo3",
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "operate",
        dataIndex: "operation",
        width: 60,
        align: 'center'
      }]
    });
    const SubmitForm = e => {
      RefForm.value.validate().then(() => {
        console.log('values11', DMConfig.Model);
        DMConfig.loading = true;
        Post("DM/SaveCustomer", DMConfig.Model).then(res => {
          if (res.succeeded) {
            _message.success('保存成功');
            context.emit('ok');
            IsShow.value = false;
          } else {
            _message.error('保存失败：' + res.errors);
            DMConfig.loading = false;
          }
        }).catch(err => {
          _message.error(err.errors);
          DMConfig.loading = false;
        });
      }).catch(error => {
        console.log(error);
        //message.error(error.message);
      });
    };

    const ResetForm = (form, DataSource) => {
      console.log('DataSource');
    };
    const GetTermsOfSaleList = () => {
      Get("/DM/GetTermsOfSaleList", {}).then(res => {
        DMConfig.TermsOfSaleList = res.data;
      });
    };
    const GetPortOfLoadingList = () => {
      Get("/DM/GetPortOfLoadingList", {}).then(res => {
        DMConfig.PortOfLoadingList = res.data;
      });
    };
    const GetSettleList = () => {
      Get("/DM/GetSettleList", {}).then(res => {
        DMConfig.SettleList = res.data;
      });
    };
    const Open = (fId, width, height) => {
      IsShow.value = true;
      DMConfig.loading = true;
      DMConfig.FId = fId;
      DMConfig.Title = (fId == 0 ? '新增' : '修改') + '客户资料';
      DMConfig.Width = width == 0 ? "100%" : width;
      DMConfig.ModelClass = width == 0 ? "full-modal" : "";
      DMConfig.Height = height == 0 ? "100%" : height;
      GetTermsOfSaleList();
      GetPortOfLoadingList();
      GetSettleList();
      if (fId > 0) {
        Get("/DM/GetCustomer", {
          id: fId
        }).then(res => {
          DMConfig.Model = res.data;
          DMConfig.loading = false;
        });
      } else {
        DMConfig.Model = {
          deliverToList: []
        };
        DMConfig.loading = false;
      }
    };
    const delRow = record => {
      const newData = DMConfig.Model['deliverToList'].filter(item => item !== record);
      DMConfig.Model['deliverToList'] = newData;
    };
    const addRow = () => {
      DMConfig.Model['deliverToList'].push({
        deliverTo: '',
        deliverTo1: '',
        deliverTo2: '',
        deliverTo3: ''
      });
    };
    return {
      IsShow,
      Open,
      delRow,
      addRow,
      RefForm,
      DMConfig,
      SubmitForm,
      ResetForm,
      GetTermsOfSaleList,
      GetPortOfLoadingList,
      GetSettleList
    };
  },
  created() {
    console.log('created');
  },
  mounted() {},
  methods: {}
};